<ng-container *ngIf="modulePermitted; else moduleNotPermitted">
    <app-ui-quoterequests-table [job]="job" (requestsLoaded)="onRequestsLoaded($event)"></app-ui-quoterequests-table>

    <div class="row" *ngIf="permissionService.isAvailable('request-for-quote.maintain-rfqs.create-edit-send-rfq') && !quoteRequestsCount">
        <div class="col-xs-12 text-center">
            <h3 class="margin-top-30 padding-top-30 margin-bottom-80">
                To create a Quote Request for this Job, select items from 'Actual Costings'
            </h3>
        </div>
    </div>

    <help-note-wrapper
        title="{{ 'helpNotes.jobs.quoteRequests.title' | translate }}"
        url="{{ 'helpNotes.jobs.quoteRequests.url' | translate }}"
        footer="Read more in our FAQ’s"
        setting="NoteJobQuote"
        [expanded]="true"
        videoUrl="{{ 'helpNotes.jobs.quoteRequests.video-url' | translate }}">
        {{ 'helpNotes.jobs.quoteRequests.text' | translate }}
    </help-note-wrapper>
</ng-container>

<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
